import { format_hours_count } from './view_case_details_record_note_helpers';

function hours_total(entries = [], billable) {
  return entries
    .filter((entry) => entry.billable === billable)
    .reduce((total, entry) => total + Number(entry.hours_value || 0), 0);
}

function billable_amount_label(hours = 0) {
  return (hours * 850).toLocaleString('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
    maximumFractionDigits: 0,
  }).replace('ZAR', 'R').trim();
}

export function time_journal_summary(entries = []) {
  const billable_hours = hours_total(entries, true);
  const non_billable_hours = hours_total(entries, false);
  const total_hours = billable_hours + non_billable_hours;

  return {
    billable_hours: format_hours_count(billable_hours),
    non_billable_hours: format_hours_count(non_billable_hours),
    total_hours: format_hours_count(total_hours),
    billable_amount: billable_amount_label(billable_hours),
  };
}
